<template>
    <v-col v-if="tourModel" class="model-tours">
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn d-flex justify-space-between">
                <h1>{{ $t("tours_models.edit_tours_models") }}</h1>
                <v-btn
                    class="delete"
                    elevation="0"
                    dark
                    small
                    @click="showConfirmDeleteDialog()"
                >
                    <v-icon class="mr-1" size="16">mdi-delete</v-icon>
                    {{ $t("global.delete") }}
                </v-btn>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_tours_models">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("tours_models.infos_tour_models") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    :label="$t('tours_models.type')"
                                    :value="tourModel.tour_type.designation"
                                    dense
                                    disabled
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    :items="sites"
                                    :label="$t('tours_models.start_site')"
                                    :loading="loadingSites"
                                    :value="tourModel.model_number.site.label"
                                    dense
                                    disabled
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    :label="$t('tours_models.number_model')"
                                    :value="tourModel.model_number.code"
                                    dense
                                    disabled
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="selectedDriver"
                                    :items="drivers"
                                    :label="$tc('tours_models.drivers', 2)"
                                    :loading="loadingDrivers"
                                    dense
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                >
                                    <template #item="{ item }">
                                        {{ item.firstname }} {{ item.lastname }}
                                    </template>
                                    <template #selection="{ item }">
                                        {{ item.firstname }} {{ item.lastname }}
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    v-model="checkboxOrder"
                                    :label="$t('tours_models.customers_order')"
                                    color="primary"
                                    hide-details="auto"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="wrap-detail-element wrap-client">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h2>{{ $tc("tours_models.customers", 2) }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col class="info-order" cols="12">
                                {{ $t("tours_models.info_order") }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <div class="header-customer">
                                    <v-checkbox
                                        v-model="selectAll"
                                        :label="$t('global.select_all')"
                                        color="primary"
                                        dark
                                        hide-details="auto"
                                    />
                                    <v-spacer/>
                                    <v-text-field
                                        v-model="search"
                                        :label="$t('global.search')"
                                        append-icon="mdi-magnify"
                                        dark
                                        dense
                                        hide-details="auto"
                                        outlined
                                        single-line
                                    />
                                </div>
                                <div class="list-group-customers">
                                    <draggable
                                        ref="lazyloading"
                                        :empty-insert-threshold="500"
                                        :list="customers"
                                        class="list-group-customers"
                                        ghost-class="ghost"
                                        group="customers"
                                    >
                                        <transition-group
                                            :name="!drag ? 'flip-list' : null"
                                            type="transition"
                                        >
                                            <div
                                                v-for="element in filteredCustomers"
                                                :key="element.id"
                                                class="list-group-item"
                                            >
                                                <div class="details">
                                                    <div class="icons">
                                                        <v-icon>
                                                            mdi-drag-vertical
                                                        </v-icon>
                                                        <v-checkbox
                                                            v-model="customerInGroup"
                                                            :value="element.id"
                                                            color="primary"
                                                            hide-details="auto"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                    <div class="infos">
                                                        <span class="name">
                                                            {{ element.name }}
                                                            -
                                                            {{ element.code }}
                                                        </span>
                                                        <span class="address">
                                                            {{ element.address_1 }}
                                                        </span>
                                                        <span class="address">
                                                            {{ element.address_2 }}
                                                        </span>
                                                        <span class="zipcode-city">
                                                            {{ element.zipcode }}
                                                            {{ element.city }}
                                                        </span>
                                                        <span class="note">
                                                            {{ element.note }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </v-col>

                            <v-col cols="12" md="6">
                                <div class="header-customer">
                                    <span class="title-total">{{ $t("tours_types.total") }}</span>
                                    <span class="nb-total">
                                        {{ selectedCustomers.length }}
                                    </span>
                                </div>
                                <div class="list-group-customers">
                                    <draggable
                                        :empty-insert-threshold="500"
                                        :list="selectedCustomers"
                                        class="list-group-customers"
                                        group="customers"
                                        v-bind="dragOptions"
                                        @add="handleAddEvent"
                                    >
                                        <transition-group
                                            :name="!drag ? 'flip-list' : null"
                                            type="transition"
                                        >
                                            <div
                                                v-for="(element, index) in selectedCustomers"
                                                :key="element.id"
                                                class="list-group-item"
                                            >
                                                <div class="details">
                                                    <div class="icons">
                                                        <v-icon>mdi-drag-vertical</v-icon>
                                                    </div>
                                                    <div class="infos">
                                                        <span class="name">
                                                             {{ element.name }}
                                                            -
                                                            {{ element.code }}
                                                        </span>
                                                        <span class="address">
                                                            {{ element.address_1 }}
                                                        </span>
                                                        <span class="address">
                                                            {{ element.address_2 }}
                                                        </span>
                                                        <span class="zipcode-city">
                                                            {{ element.zipcode }}
                                                            {{ element.city }}
                                                        </span>
                                                        <span class="note">
                                                            {{ element.note }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="index">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    class="icons-end"
                                                    @click="removeFromSelected(index, element)"
                                                >
                                                    <v-icon>mdi-close</v-icon>
                                                </div>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="container-button">
                    <v-btn
                        :loading="loadingSave"
                        color="primary"
                        elevation="0"
                        @click="save"
                    >
                        {{ $t("global.save") }}
                    </v-btn>
                </div>
            </v-form>
        </div>
        <confirm-delete
            :message="$t('tours_models.going_to_delete', [modelFullName])"
            :visible="confirm_dialog"
            @close="confirm_dialog = false"
            @validate="deleteTourModel()"/>
    </v-col>
    <v-col v-else>
        {{ $t("global.loading") }}
    </v-col>
</template>

<script>
import Draggable from "vuedraggable";
import tour_models from "../../../mixins/tour_models";
import ConfirmDelete from "../../../components/dialogs/confirmDelete"

export default {
    name: "EditToursModels",
    components: {
        Draggable,
        ConfirmDelete,
    },
    mixins: [tour_models],
    data() {
        return {
            tourModel: null,
            confirm_dialog: false,
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
        modelFullName() {
            return this.tourModel.model_number.site.code + this.tourModel.model_number.code + ' - ' + this.tourModel.tour_type.designation
        }
    },
    async mounted() {
        this.tourModel = (
            await this.$api.tour_models.get(this.$route.params.id, {
                params: {
                    includes:
                        "tour_model.model_number,model_number.site,tour_model.tour_type",
                },
            })
        ).data.data;
        this.selectedDriver = this.tourModel.driver_id;
        this.checkboxOrder = this.tourModel.is_ordered;
        this.getDrivers();
        this.customers = await (this.getCustomers({
            params: {
                notInTypeId: this.tourModel.tour_type.id,
            },
        }));
        this.getTourModelCustomers();
    },
    methods: {
        async getTourModelCustomers() {
            this.selectedCustomers = (
                await this.$api.tour_models.get_customers(this.tourModel.id, {
                    params: {
                        per_page: -1
                    }
                })
            ).data.data;
        },
        updateTourModel() {
            this.$api.tour_models.update(this.tourModel.id, {
                driver_id: this.selectedDriver,
                is_ordered: this.checkboxOrder,
            });
        },
        save() {
            this.updateTourModel()
            this.addCustomerToTourModel(this.tourModel.id)
            this.$router.push({name: 'tours_models'})
        },
        showConfirmDeleteDialog() {
            this.confirm_dialog = true;
        },
        deleteTourModel() {
            this.$api.tour_models.delete(this.$route.params.id);
            this.$router.push({name: 'tours_models'})
        },
        async getNextPage() {
            if (this.page <= this.lastPage) {
                this.page = this.page + 1
                const customers = await (this.getCustomers({
                    params: {
                        notInTypeId: this.tourModel.tour_type.id,
                        page: this.page,
                        customer_search: this.search
                    },
                }))
                this.customers = this.customers.concat(customers)
            }
        },
        async getSearch() {
            this.page = 1
            this.customers = await (this.getCustomers({
                params: {
                    notInTypeId: this.tourModel.tour_type.id,
                    page: this.page,
                    customer_search: this.search
                },
            }))
        }
    }
}
</script>
